<ng-container *ngIf="matLabel">
  <label class="d-block mb-12 fw-semibold gray-color">{{matLabel}}</label>
</ng-container>
<mat-form-field [appearance]="appearance" class="date-input w-100">
    <mat-label>{{ label }}</mat-label>
    <input matInput 
           [matDatepicker]="picker"
           [formControl]="dateControl"
           (dateChange)="onDateChange($event)"
           [max]="maxDate">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="dateControl.hasError('required')">
      Date is required
    </mat-error>
  </mat-form-field>